import React from 'react';

const InputError = ({ meta }) => {
  if (meta.touched && meta.error) {
    return <span className={'input-error has-error'}>{meta.error}</span>;
  }
  return null;
};

export default InputError;
